
    <girko-login *ngIf="!isProduction"></girko-login>
    <girko-header-connected *ngIf="showHeader$ | async" (hamburgerClick)="sidenav.toggle()"></girko-header-connected>
    <mat-sidenav-container class="user-cabinet-container" (backdropClick)="sidenav.close()">
      <mat-sidenav
        #sidenav
        [mode]="mobileQuery.matches ? 'over' : 'side'"
        [opened]="!mobileQuery.matches && (service$ | async)?.active"
        (keydown.escape)="sidenav.close()"
      >
        <mat-nav-list>
          <a
            mat-list-item
            routerLinkActive="active"
            *ngFor="let route of routes"
            (click)="onMenuItemClick(sidenav)"
            [routerLink]="[route.path]"
            >
            {{route.title | async}}
          </a>
        </mat-nav-list>
      </mat-sidenav>
      <mat-sidenav-content>
         <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  